import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User joined a library',
  name: 'joined_library',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
